var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sprintf } from "sprintf-js";
// import { _mousePenDebugMode } from "../..";
import { PenEventName } from "../common/enums/PenEnums";
import { NEO_SMARTPEN_TYPE } from "../common/neopen/INeoSmartpen";
import { InkStorage } from "../common/penstorage";
// import PUIController from "../../components/PUIController";
import SmartPenBase from "./SmartPenBase";
const _mousePenDebugMode = false;
// const NUM_HOVER_POINTERS = 6;
export default class VirtualPen extends SmartPenBase {
    /**
     * Creates an instance of VirtualPen.
     * @param {InkStorage} [customStorage=null]
     * @memberof VirtualPen
     */
    constructor(customStorage = null) {
        super(_mousePenDebugMode ? InkStorage.get2ndInstance() : customStorage, undefined, undefined);
        /**
         *
         *
         * @memberof VirtualPen
         */
        this.getBtDevice = () => {
            return undefined;
        };
        this.getMac = () => {
            return this.mac;
        };
        /**
         *
         *
         * @return {*}  {Promise<boolean>}
         * @memberof VirtualPen
         */
        this.connect = (requestOnlineDataOnConencted = true) => __awaiter(this, void 0, void 0, function* () {
            // this.manager.onConnected({ pen: this, event });
            this.dispatcher.dispatch(PenEventName.ON_CONNECTED, {
                inputType: this.inputType,
                pen: this,
                mac: this.mac,
                event: undefined
            });
            return true;
        });
        /**
         *
         *
         * @param {BluetoothDevice} device
         * @return {*}
         * @memberof VirtualPen
         */
        this.connectByWebBtDevice = (device) => __awaiter(this, void 0, void 0, function* () {
            return true;
        });
        /**
         *
         *
         * @memberof VirtualPen
         */
        this.disconnect = () => {
            this.dispatcher.dispatch(PenEventName.ON_DISCONNECTED, {
                inputType: this.inputType,
                pen: this,
                mac: this.getMac(),
            });
            // throw new Error(`disconnecting virtual pen has not been implemented.`);
        };
        console.log(_mousePenDebugMode);
        this.maxPenPressureValue = VirtualPen.virtualPenMaxPressure;
        this.inputType = VirtualPen.getInputType();
        this.connected = true;
        this.protocolHandler = null;
        const color = this.manager.color;
        for (let i = 0, l = this.penState.length; i < l; i++) {
            this.penState[i] = {
                thickness: 0.2,
                color: color,
            };
        }
        const { mac, webBluetoothId } = VirtualPen.generateVirualPenMacAndId();
        this.mac = mac;
        this.webBluetoothId = webBluetoothId;
    }
    static generateVirualPenMacAndId() {
        const penMacString = VirtualPen.virtualPenMacString;
        const mac = sprintf("%02x:%02x:%02x:%02x:%02x:%02x", penMacString.charCodeAt(0), penMacString.charCodeAt(1), penMacString.charCodeAt(2), penMacString.charCodeAt(3), penMacString.charCodeAt(4), penMacString.charCodeAt(5));
        const webBluetoothId = "mouse-" + mac;
        return { mac, webBluetoothId };
    }
    static getInputType() {
        return NEO_SMARTPEN_TYPE.MOUSE_PEN;
    }
}
VirtualPen.virtualPenMaxPressure = 800;
VirtualPen.virtualPenMacString = "_MOUSE";
//# sourceMappingURL=VirtualPen.js.map